"use strict";

var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateShippingCosts = exports.estimateShippingCostsForLines = exports.getCurrentShippingCosts = void 0;
var ajax_1 = require("../ajax");
var cart_1 = require("../cart");
/**
 * Returns the shipping rates for the current cart object.
 *
 * @param zip Destination zip code
 * @param country Destination country
 * @param province Destination province code (exact match only)
 */
exports.getCurrentShippingCosts = function (zip, country, province) {
    return ajax_1.shopifyGet('/cart/shipping_rates.json', { shipping_address: { zip: zip, country: country, province: province } });
};
exports.estimateShippingCostsForLines = function (lines, zip, country, province) {
    return __awaiter(void 0, void 0, void 0, function () {
        var oldCart, adds, rates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    oldCart = cart_1.getCurrentCart();
                    if (!oldCart.items.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, ajax_1.shopifyGet('/cart/clear.js')];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    return [4 /*yield*/, Promise.all(lines.map(function (line) {
                        return ajax_1.shopifyGet('/cart/add.js', {
                            id: line.variantId, quantity: line.quantity,
                            properties: __assign(__assign({}, line.properties || {}), { _shipping_calc: 'Y' })
                        });
                        // return addToCart(line.variantId, line.quantity, {
                        //   ...(line.properties||{}), _shipping_calc: 'Y'
                        // });
                    }))];
                case 3:
                    adds = _a.sent();
                    return [4 /*yield*/, exports.getCurrentShippingCosts(zip, country, province)];
                case 4:
                    rates = _a.sent();
                    //Clear cart
                    return [4 /*yield*/, ajax_1.shopifyGet('/cart/clear.js')];
                case 5:
                    //Clear cart
                    _a.sent();
                    //Add existing lines
                    return [4 /*yield*/, Promise.all(oldCart.items.map(function (line) {
                        return ajax_1.shopifyGet('/cart/add.js', {
                            id: line.variant_id, quantity: line.quantity,
                            properties: __assign({}, line.properties || {})
                        });
                        // return addToCart(line.variant_id, line.quantity, line.properties);
                    }))];
                case 6:
                    //Add existing lines
                    _a.sent();
                    return [2 /*return*/, rates];
            }
        });
    });
};
exports.estimateShippingCosts = function (variantId, quantity, zip, country, province) {
    return exports.estimateShippingCostsForLines([{ variantId: variantId, quantity: quantity }], zip, country, province);
};
//# sourceMappingURL=index.js.map